export const getFileExtensionFromContentType = (contentType) => {
    const fileExtension = contentType === "application/pdf" ? 'pdf' : 'txt';
    return fileExtension;
}